module.exports = __webpack_public_path__ + "static/media/Tock.b6789b1d.wav";